import { render, staticRenderFns } from "./AddClass.vue?vue&type=template&id=3fa76f08&scoped=true"
import script from "./AddClass.vue?vue&type=script&lang=js"
export * from "./AddClass.vue?vue&type=script&lang=js"
import style0 from "./AddClass.vue?vue&type=style&index=0&id=3fa76f08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa76f08",
  null
  
)

export default component.exports